export { default as WindowMinimizeOutlineIcon } from './WindowMinimizeOutlineIcon';
